import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTabAccess } from '@/hooks/use-tab-access'

export default function RedirectPage() {
  const navigate = useNavigate()
  const { allowedTabs, isLoading } = useTabAccess()

  useEffect(() => {
    if (isLoading) return

    const preferredOrder = [
      'dashboard',
      'team-assignments',
      'credentials',
      'projects',
      'employees',
      'clients',
      'leaves',
      'ssm',
      'rdp-servers',
      'settings',
    ]

    const firstTab = preferredOrder.find(tab => allowedTabs.includes(tab))
    navigate(firstTab ? `/${firstTab}` : '/credentials', { replace: true })
  }, [allowedTabs, isLoading, navigate])

  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-muted-foreground text-sm">Loading...</div>
    </div>
  )
}
